import services from "../../../http/index";

export const ActionDoSaveMedicalRecord = (context, payload) => {
    return services.api.request({
        url: `medical-records`,
        method: "post",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionDoGetMedicalRecord = (context, session_id) => {
    return services.api.request({
        url: `medical-records/${session_id}`,
        method: "get"
    }).then(response => {
        return response.data;
    });
};

export const ActionDoUploadAttachment = (context, { record_id, formData }) => {
    return services.api.request({
        url: `medical-records/${record_id}/attachments`,
        method: "post",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then(response => {
        return response.data;
    });
};

export const ActionDoDeleteAttachment = (context, attachment_id) => {
    return services.api.request({
        url: `medical-records/attachments/${attachment_id}`,
        method: "delete"
    }).then(response => {
        return response.data;
    });
};

export const ActionDoExportCustomerPdf = (context, customer_id) => {
    return services.api.request({
        url: `medical-records/export/customer/${customer_id}`,
        method: "get",
        responseType: "blob"
    }).then(response => {
        return response; // Return full response to get headers and blob
    });
};

export const ActionDoExportSelectedPdf = (context, payload) => {
    return services.api.request({
        url: `medical-records/export/selected`,
        method: "post",
        data: payload,
        responseType: "blob"
    }).then(response => {
        return response; // Return full response to get headers and blob
    });
};
